import { gql } from '@apollo/client';

export const CHANGE_ROLE_FOR_DELETE_USER = gql`
  mutation changeRoleForDeleteUser($input: ChangeRoleInput!) {
    changeRole(input: $input) {
      client {
        id
      }
    }
  }
`;

export interface ChangeRoleForDeleteUserQueryVariables {
  input: {
    userRoleChanges: UserRoleChange[];
  };
}

interface UserRoleChange {
  id: string;
  roleCodes: string[];
  delete: boolean;
}
